import { defineStore } from 'pinia'
import actions from './actions'
import getters from './getters'

const namespaced = true

const state = () => ({
  articleCategories: {
    en: [],
    es: []
  },
  homeContent: [],
  activeContent: {
    type: '',
    id: '',
    slug: ''
  }
})

export const communityV2Store = defineStore('communityV2', {
  namespaced,
  state: () => state(),
  actions,
  getters
})

export default communityV2Store
